// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDynamicFormByIdRequestModel from '../../model/get-dynamic-form-by-id-request-model';
import GetDynamicFormByIdRequestDTO from '../dto/get-dynamic-form-by-id-request-dto';
import dtoSchema from '../schemas/get-dynamic-form-by-id-request-schema';

export default abstract class GetDynamicFormByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDynamicFormByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetDynamicFormByIdRequestDTO>): GetDynamicFormByIdRequestModel;
  static toModel(dto: DeepPartial<GetDynamicFormByIdRequestDTO> | undefined | null): GetDynamicFormByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDynamicFormByIdRequestDTO> | undefined | null): GetDynamicFormByIdRequestModel | undefined {
    return dto ? new GetDynamicFormByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDynamicFormByIdRequestModel> | GetDynamicFormByIdRequestModel): GetDynamicFormByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetDynamicFormByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDynamicFormByIdRequestModel, can not map to GetDynamicFormByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
